export const SurveyModel = Object.freeze({
  // Periodo rilevazione
  year: null,
  quarter: null,
  week: null,
  start_date: null,
  end_date: null,

  // Dati automezzo oggetto di rilevazione
  vehicle_targa: null,
  vehicle_load_capacity: null,
  vehicle_province: null,
  vehicle_transport_type: null,
  vehicle_type: null,

  // Dati ISTAT sull'azienda
  company_name: '',
  company_address: '',
  company_city: '',
  company_province: '',

  // Token invito
  token: null,

  // Validità questionario
  valid_from: null,
  valid_until: null,

  // Campione
  sample: '',

  // Impresa
  company: {
    city: null,
    address: '',
    name: '',
    ateco: null,
    zip: '',
  },

  // Referente
  referent: {
    name: '',
    phone: '',
    email: '',
  },

  // Parco automezzi
  fleet: {
    vehicles: { owned: 0, leasing: 0, rent: 0 },
    tractors: { owned: 0, leasing: 0, rent: 0 },
    trailers: { owned: 0, leasing: 0, rent: 0 },
    semitrailers: { owned: 0, leasing: 0, rent: 0 },
  },

  // Proprietà automezzo
  ownership: {
    changed: null,
    reason: null,
    date: null,
  },

  vehicle_stopped: null,
  vehicle_fuel_consumed: null,

  // Viaggi
  journeys: [],

  // Meta dati
  _meta: {},

  last_page: null,

  // Timestamp
  started_at: null,
  submitted_at: null,

  created_at: null,
  updated_at: null,
})

export const JourneyModel = Object.freeze({
  id: null,

  // Viaggio precedente e successivo
  previous_id: null,
  next_id: null,

  // Date
  day: null,
  date: null,

  // Tipologie
  type: null, // 1=STANDARD, 2=CIRCUITO, 3=NAVETTA
  type1: null,
  type2: null,

  // Viaggio precedente in caso di multi tappa
  parent_id: null,

  // Località di partenza/origine
  origin: null,
  origin_type: null,

  // Località di arrivo/destinazione
  destination: null,
  destination_type: null,

  // Distanze
  distance_total: null,
  distance_empty: null,
  distance_loaded: null,

  // Viaggio internazionale
  crossed_border: null,
  crossed_countries: [],

  // Automezzo agganciato
  coupled_vehicle: null,
  coupled_vehicle_axles: null,
  coupled_vehicle_load_capacity: null,

  // Automezzo imbarcato su nave o treno
  embarking: false,
  embarking_type: null,
  embarking_from: null,
  embarking_to: null,

  // Viaggi
  journeys_count: null,

  // Fermate
  stops_count: null,
  stops_province_count: null,

  // Merci
  // goods: {
  //   0: null,
  //   1: null,
  //   2: null,
  // },
  goods: [],

  exceptional_transport: false,
  exceptional_transport_desc: null,

  // Viaggio a vuoto
  is_empty: false,

  // Finale
  is_ended: null,

  // Meta dati
  _meta: {},

  // Timestamp
  created_at: null,
  updated_at: null,
})

export const GoodsModel = Object.freeze({
  type: null,
  aspect: null,
  dangerous: null,

  weight: null,
  weights: {
    loaded: null,
    unloaded: null,
    onboard: 0,
    remaining: 0,
  },

  _meta: {},

  is_inherited: false,
  map: null,
})

export const createSurveyInstance = () => {
  return JSON.parse(JSON.stringify(SurveyModel))
}

export const createGoodsInstance = () => {
  return JSON.parse(JSON.stringify(GoodsModel))
}

export const createJourneyInstance = () => {
  return JSON.parse(JSON.stringify(JourneyModel))
}

export const GoodsA = Object.freeze({
  type_id: null,
  aspect_id: null,
  dangerous_id: null,
  weight: null,

  _meta: {
    map: null,
  },
})

export const GoodsB = Object.freeze({
  type_id: null,
  aspect_id: null,
  dangerous_id: null,

  loaded_weight: null,
  unloaded_weight: null,

  _meta: {
    map: null,
    onboard_weight: 0,
    remaining_weight: 0,
    is_inherited: 0,
  },
})
